<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">点数购买记录</span>
    </h2>
    <breadcrumb firstName="门店账户"></breadcrumb>
    <div class="scroll_container">
      <div class="handBar">
        <div class="pay__no">
          <common-input v-model="form.refSeqNo" placeholder="请输入">
            <template slot="before">
              <span>支付流水号</span>
            </template>
          </common-input>
        </div>
        <div class="payno">
          <common-input v-model="form.payId" placeholder="请输入">
            <template slot="before">
              <span>支付编号</span>
            </template>
          </common-input>
        </div>
        <div class="selectPayType">
          <el-select v-model="form.payWay" clearable placeholder="支付方式">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="SelectTime">
          <el-date-picker
            v-model="form.time"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            :picker-options="pickerOptions"
            class="zy-date-picker"
          ></el-date-picker>
        </div>
        <div class="showBtn" @click="showData()">
          <span>查看</span>
        </div>
        <div class="showBtn" @click="DownloadData()">
          <span>导出</span>
        </div>
      </div>
      <div class="table_container">
        <el-table
          stripe
          row-key="payId"
          :data="tableData"
          size="medium"
          header-row-class-name="common-table-header"
          row-class-name="common-table-row"
          class="is-print-hide common-table"
          :border="true"
        >
          <el-table-column prop="payId" label="支付编号">
            <template slot-scope="scope">
              <div class="overbox">
                <el-tooltip effect="dark" :open-delay="500" :content="scope.row.payId" placement="top">
                  <span>
                    {{ scope.row.payId }}
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="payWay" label="支付方式">
            <template slot-scope="scope">
              <span>{{ renderPayWay(scope) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="refSeqNo" label="支付流水号">
            <template slot-scope="scope">
              <div class="overbox">
                <el-tooltip effect="dark" :open-delay="500" :content="scope.row.refSeqNo" placement="top">
                  <span>
                    {{ scope.row.refSeqNo }}
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="支付金额（元）">
            <template slot-scope="scope">
              <div class="overbox">
                <el-tooltip effect="dark" :open-delay="500" :content="renderMoney(scope)" placement="top">
                  <span>
                    {{ renderMoney(scope) }}
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="rechargeCoin" label="充值点数">
            <template slot-scope="scope">
              <div class="overbox">
                <el-tooltip
                  effect="dark"
                  :open-delay="500"
                  :content="(scope.row.rechargeCoin || '').toString()"
                  placement="top"
                >
                  <span>
                    {{ scope.row.rechargeCoin }}
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="coinAfterCharge" label="充值后点数">
            <template slot-scope="scope">
              <div class="overbox">
                <el-tooltip
                  effect="dark"
                  :open-delay="500"
                  :content="(scope.row.coinAfterCharge || '').toString()"
                  placement="top"
                >
                  <span>
                    {{ scope.row.coinAfterCharge }}
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="successTime" label="到账时间">
            <template slot-scope="scope">
              <div class="overbox">
                <el-tooltip effect="dark" :open-delay="500" :content="renderTime(scope)" placement="top">
                  <span>
                    {{ renderTime(scope) }}
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <span>{{ renderStatus(scope) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="form.pageNo"
          :page-size="form.pageSize"
          layout="prev, pager, next, total, jumper"
          :total="form.totalCount"
          class="is-print-hide common-el-pagination"
        ></el-pagination>
        <div class="sureJump global_common_button_goast">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumb from '@/components/global/breadcrumb';
import commonInput from '@/components/global/form/common_input';
import { baseFormat } from '@fastweb/f2e-utils';
import { transformParamToUrl, downloadByIframe } from '@/util/index';
import dayjs from 'dayjs';

export default {
  components: {
    breadcrumb,
    commonInput
  },
  data() {
    return {
      form: {
        refSeqNo: '',
        payId: '',
        payWay: null,
        time: [],
        pageNo: 1,
        pageSize: 10,
        totalCount: 0
      },
      tableData: [],
      options: [
        {
          value: '99',
          label: '全部'
        },
        {
          value: '1',
          label: '支付宝'
        },
        {
          value: '2',
          label: '微信'
        }
      ],
      pickerOptions: {
        disabledDate: time => {
          return this.dealDisabledDate(time);
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近两周',
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近三周',
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 21);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近一个月',
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近两个月',
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近三个月',
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          }
        ]
      }
    };
  },
  methods: {
    async DownloadData() {
      let res = await this._getData();
      if (this.form.totalCount > 20000) {
        this.$message({
          message: '此次导出数据超过2万条，请缩小查询范围后导出',
          type: 'error'
        });
      } else {
        const params = {
          payId: this.form.payId,
          refSeqNo: this.form.refSeqNo,
          startTime: this.formatStartTime(),
          endTime: this.JudgeprescriptionEndTime(),
          payWay: this.form.payWay == 99 ? null : this.form.payWay,
          status: 1, // 查询充值成功的
          pageNo: this.form.pageNo,
          pageSize: this.form.pageSize
        };
        const baseUrl = `${Util.getGwRoot}drugstore/1.0/export_user_recharge_order`;
        const str = transformParamToUrl(params);
        const openUrl = `${baseUrl}?${str}`;
        console.log(openUrl);

        downloadByIframe(openUrl, '点数购买记录');
      }
    },
    handleCurrentChange(val) {
      this.form.pageNo = val;
      this._getData();
    },
    JudgeprescriptionEndTime() {
      // 后端要求获取当天数据时间戳需要+一天
      // 时间戳转年月日再转时间戳
      // return this.form.time[1] + 86400000;
      if (!(this.form.time && this.form.time[1])) {
        return null;
      }
      return +dayjs(dayjs(this.form.time[1] + 86400000).format('YYYY-MM-DD')).format('x');
    },
    formatStartTime() {
      // 时间戳转年月日再转时间戳
      // return dayjs(this.form.time[0] * 1);
      if (!(this.form.time && this.form.time[0])) {
        return null;
      }
      return +dayjs(dayjs(this.form.time[0] * 1).format('YYYY-MM-DD')).format('x');
    },
    renderStatus(sc) {
      if (sc.row.status == 1) {
        return '充值成功';
      }
      if (sc.row.status == 2) {
        return '待支付';
      }
      if (sc.row.status == 3) {
        return '已取消';
      }
      if (sc.row.status == 4) {
        return '已过期';
      }
      if (sc.row.status == 5) {
        return '待充值';
      }
    },
    renderTime(sc) {
      // 渲染支付时间
      let time = baseFormat(sc.row.successTime, 'YYYY-MM-DD HH:mm:ss');
      return time;
    },
    renderMoney(sc) {
      // 渲染支付金额
      return sc.row.price / 100 + '元';
    },
    renderPayWay(scope) {
      // 渲染支付方式
      if (scope.row.payWay == 1) {
        return '支付宝';
      }
      if (scope.row.payWay == 2) {
        return '微信';
      }
    },
    dealDisabledDate(time) {
      // 90天前跟今天后都不能选
      /* if (
        time.getTime() >
          dayjs()
            .subtract(0, 'days')
            .format('x') ||
        time.getTime() <
          dayjs()
            .subtract(90, 'days')
            .format('x')
      ) {
        return true;
      } */
    },
    showData() {
      // 查看
      this._getData();
    },
    showAllData() {
      // 时间选择器使用
      this._getData();
    },
    async _getData() {
      const params = {
        payId: this.form.payId || null,
        refSeqNo: this.form.refSeqNo || null,
        startTime: this.formatStartTime() || null,
        endTime: this.JudgeprescriptionEndTime() || null,
        payWay: this.form.payWay == 99 ? null : this.form.payWay,
        status: 1, // 查询充值成功的
        pageNo: this.form.pageNo,
        pageSize: this.form.pageSize
      };
      /* let str = transformParamToUrl(params);
      let arrStr = str.split('&');
      let obj = {};
      arrStr.map(v => {
        let key = v.split('=')[0];
        let value = v.split('=')[1];
        obj[key] = value;
      });
      console.log(str, obj, 'str'); */

      let res = await Fetch.user_recharge_order_page(params);
      this.tableData = res.data;
      this.form.totalCount = res.totalCount;
    }
  },
  mounted() {
    this._getData();
  }
};
</script>
<style lang="scss" scoped>
.overbox {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.scroll_container {
  padding: 16px;
  box-shadow: 0px 4px 12px 0px rgba(237, 237, 237, 1);
  border-radius: 4px;
  border: 1px solid rgba(242, 242, 242, 1);
  background: #fff;
  .handBar {
    &:after {
      content: '.';
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    .baseHandbars {
      float: left;
      margin-right: 16px;
      margin-bottom: 16px;
    }
    .pay__no {
      @extend .baseHandbars;
    }
    .payno {
      @extend .baseHandbars;
    }
    .selectPayType {
      @extend .baseHandbars;
    }
    .SelectTime {
      @extend .baseHandbars;
    }
    .showBtn {
      @extend .baseHandbars;
      float: left;
      cursor: pointer;
      background: #fff;
      color: #1e8dff;
      height: 40px;
      width: 80px;
      border: 1px solid #1e8dff;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
      border-radius: 4px;
      &:hover {
        background: rgba(68, 184, 91, 0.1);
      }
    }
  }
  .footer {
    overflow: hidden;
    display: flex;
    justify-content: center;
    position: relative;
    .selectAll {
      position: absolute;
      left: 16px;
      top: 24px;
    }
    .sureJump {
      // float: left;
      width: 80px;
      height: 32px;
      // color: #1E8DFF;
      // background: #ffffff;
      // border: 1px solid #1E8DFF;
      border-radius: 3px;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
      margin-left: 10px;
      margin-top: 22px;
    }
    .disabled_page {
      position: absolute;
      display: flex;
      align-items: center;
      right: 20px;
      top: 30px;
      cursor: pointer;
    }
  }
}
</style>
